import React from 'react';
import PropTypes from 'prop-types';

import Card from '@material-ui/core/Card';
import Grid from '@material-ui/core/Grid';
import Hidden from '@material-ui/core/Hidden';
import Divider from '@material-ui/core/Divider';

import MoneyIcon from '@material-ui/icons/AttachMoney';
import MethodIcon from '@material-ui/icons/CreditCard';
import TodayIcon from '@material-ui/icons/TodayOutlined';
import EventIcon from '@material-ui/icons/EventOutlined';
import RepeatIcon from '@material-ui/icons/RepeatOutlined';
import EventAvailableIcon from '@material-ui/icons/EventAvailableOutlined';
import BalanceIcon from '../../../components/Icons/Balance/Balance.js';

import IndentedCardContent from '../../../components/IndentedCardContent/IndentedCardContent.js';
import BigIconFieldReadOnly from '../../../components/BigIconFieldReadOnly/BigIconFieldReadOnly';

import {
  getString,
  stringToCurrency,
  stringToDate,
} from '../../../helpers/stringHelpers.js';

import { withStyles } from '@material-ui/core/styles';
import styles from './styles.js';

class ArrangementBalanceCard extends React.Component {
  render() {
    const { classes, helpText, data } = this.props;

    const {
      originalArrangementBalance,
      arrangementBalance,
      paymentAmount,
      paymentMethod,
      paymentFrequency,
      paymentStartDate,
      paymentEndDate,
      nextArrangementPaymentDate,
    } = data;

    const stringsComponent = 'arrangements';

    const body = (
      <div className={classes.bodyContainer}>
        <Grid container spacing={16}>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'NEXT_PAYMENT_DATE_LABEL')}
              value={stringToDate(nextArrangementPaymentDate)}
              icon={EventIcon}
            />
          </Grid>
          <Hidden mdUp>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'PAYMENT_AMOUNT_LABEL')}
              value={stringToCurrency(paymentAmount)}
              icon={MoneyIcon}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'ORIGINAL_BALANCE_LABEL')}
              value={stringToCurrency(originalArrangementBalance)}
              icon={BalanceIcon}
            />
          </Grid>
          <Hidden mdUp>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'REMAINING_BALANCE_LABEL')}
              value={stringToCurrency(arrangementBalance)}
              icon={BalanceIcon}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'PAYMENT_METHOD_LABEL')}
              value={paymentMethod}
              icon={MethodIcon}
            />
          </Grid>
          <Hidden mdUp>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'PAYMENT_FREQUENCY_LABEL')}
              value={paymentFrequency}
              icon={RepeatIcon}
            />
          </Grid>
          <Grid item xs={12}>
            <Divider />
          </Grid>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'START_DATE_LABEL')}
              value={stringToDate(paymentStartDate)}
              icon={TodayIcon}
            />
          </Grid>
          <Hidden mdUp>
            <Grid item xs={12}>
              <Divider />
            </Grid>
          </Hidden>
          <Grid item xs={12} md={6}>
            <BigIconFieldReadOnly
              label={getString(stringsComponent, 'END_DATE_LABEL')}
              value={stringToDate(paymentEndDate)}
              icon={EventAvailableIcon}
            />
          </Grid>
        </Grid>
      </div>
    );

    return (
      <div className={classes.root}>
        <Card className='Card'>
          <IndentedCardContent body={body} helpText={helpText} />
        </Card>
      </div>
    );
  }
}

ArrangementBalanceCard.propTypes = {
  classes: PropTypes.object.isRequired,
  helpText: PropTypes.string,
  data: PropTypes.shape({
    originalArrangementBalance: PropTypes.string,
    arrangementBalance: PropTypes.string,
    paymentAmount: PropTypes.string,
    paymentMethod: PropTypes.string,
    paymentFrequency: PropTypes.string,
    paymentStartDate: PropTypes.string,
    paymentEndDate: PropTypes.string,
  }),
};

ArrangementBalanceCard.defaultProps = {
  helpText: null,
  type: null,
  data: {
    originalArrangementBalance: '',
    arrangementBalance: '',
    paymentAmount: '',
    paymentMethod: '',
    paymentFrequency: '',
    paymentStartDate: '',
    paymentEndDate: '',
  },
};

export default withStyles(styles)(ArrangementBalanceCard);
